import React from 'react';
import AdvancedSearch from '../AdvancedSearch';
import { useLanguage } from '../../../context/LanguageContext';

const Drafts = () => {
    const { t } = useLanguage();

    return <AdvancedSearch title={t('pages.marketing.drafts')} defaultSpecificStatuses={['Draft', 'Waiting_validate']} />;
};

export default Drafts;
